// Import vlastní funkcionality pro open map lazy loading
import { performOpenStreetMapLoading } from "./open-street-map-functions";

const options = {
  rootMargin: "0px",
  threshold: 0,
};

const MAP_CONTAINER_SELECTOR = ".map-container";

let startedLoadingMap = false;

// # Původní závislosti knihovny
const CSS_DEPENDENCY_INFO = Object.freeze({
  rel: "stylesheet",
  integrity:
    "sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ==",
  crossOrigin: "",
  href: "https://unpkg.com/leaflet@1.6.0/dist/leaflet.css",
});

const JS_DEPENDENCY_INFO = Object.freeze({
  integrity:
    "sha512-gZwIG9x3wUXg2hdXF6+rVkLF/0Vi9U8D2Ntg4Ga5I5BZpVkVxlJWbSQtXPSiUTtC0TjtGOmxa1AJPuV0CPthew==",
  crossOrigin: "",
  src: "https://unpkg.com/leaflet@1.6.0/dist/leaflet.js",
});

// Kontrola kdyby někdo na stránku už přidal závislosti mapy
// V tom případě lazy loading nepoužíváme a styly jsou na stránce rovnou
const dependenciesAlreadyExist = () => {
  return (
    document.querySelector(`link[href="${CSS_DEPENDENCY_INFO.href}"]`) ||
    document.querySelector(`script[src="${JS_DEPENDENCY_INFO.src}"]`)
  );
};

const attachMapCSS = () => {
  const mapCSS = document.createElement("link");
  mapCSS.rel = CSS_DEPENDENCY_INFO.rel;
  mapCSS.integrity = CSS_DEPENDENCY_INFO.integrity;
  mapCSS.crossOrigin = CSS_DEPENDENCY_INFO.crossOrigin;
  mapCSS.href = CSS_DEPENDENCY_INFO.href;

  mapCSS.onload = attachMapScript;

  document.head.appendChild(mapCSS);
};

const attachMapScript = () => {
  const scriptElement = document.createElement("script");
  scriptElement.integrity = JS_DEPENDENCY_INFO.integrity;
  scriptElement.crossOrigin = JS_DEPENDENCY_INFO.crossOrigin;
  scriptElement.src = JS_DEPENDENCY_INFO.src;

  scriptElement.onload = () => {
    performOpenStreetMapLoading();
    removeObserver();
  };

  document.head.appendChild(scriptElement);
};

const removeObserver = () => {
  observer.disconnect();
};

const attachMapDependencies = () => {
  attachMapCSS();
};

/**
 * @param {IntersectionObserverEntry[]} entries
 */
const onMapContainerIntersection = (entries) => {
  // Check pro první default call
  const intersectingAny = entries.some((entry) => entry.isIntersecting);

  if (!intersectingAny || startedLoadingMap) {
    return;
  }

  startedLoadingMap = true;
  attachMapDependencies();
};

const observer = new IntersectionObserver(onMapContainerIntersection, options);

document.addEventListener("DOMContentLoaded", () => {
  if (dependenciesAlreadyExist()) {
    return;
  }

  const mapContainers = document.querySelectorAll(MAP_CONTAINER_SELECTOR);

  mapContainers.forEach((mapContainer) => {
    observer.observe(mapContainer);
  });
});
